import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Device } from '@capacitor/device';

@Component({
  selector: 'app-enviroment-state',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './enviroment-state.component.html',
  styleUrl: './enviroment-state.component.scss'
})
export class EnviromentStateComponent implements OnInit {

  environment = environment;
  platform: string = '';
  deviceInfo: any;
  isIos: boolean = false;

  async ngOnInit() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.deviceInfo = await Device.getInfo();
    this.platform = this.deviceInfo.platform;
  }
}